import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../public/utility'
import { concat } from 'lodash'
import EvaluateContentDiv from './EvaluateContentDiv'
import EvaluateTitleDiv from './EvaluateTitleDiv'
import AddEvaluateItemDiv from './AddEvaluateItemDiv'

class EvaluateItemDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { id } = this.props
        this.handlerInitValue(id)
    }

    handlerInitValue = (id) => {
        Tyan.doPostEvent({
            event: 'GetEvaluateItem',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {} })
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteEvaluateItem',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }))
    }


    AddEvaluateTitle = () => {
        const { id: evaluateItemID } = this.state
        Tyan.pubForm.showDialog('评价标题', props => <EvaluateTitleDiv {...props} evaluateItemID={evaluateItemID} id={0}
            onSave={() => this.handlerInitValue(evaluateItemID)} />)
    }

    handlerDeleteTitle = (id) => {
        const { id: evaluateItemID } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteEvaluateTitle',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    this.handlerInitValue(evaluateItemID)
                }
            }))
    }

    handlerDeleteContent = (id) => {
        const { id: evaluateItemID } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteEvaluateContent',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    this.handlerInitValue(evaluateItemID)
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        const { list } = getListItems(this, '基本信息', '评价项')
        return getFormValue(this, '基本信息', '评价项目名称') && list.filter(o => !o.名称).length == 0
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerAddEvaluateContent = (id) => {
        const { id: evaluateItemID } = this.state
        Tyan.pubForm.showDialog('评价内容', props => <EvaluateContentDiv {...props} id={0} evaluateTitleID={id} onSave={() => this.handlerInitValue(evaluateItemID)} />)
    }

    fieldset基本信息 = () => {
        const { id } = this.state
        const { list } = getListItems(this, '基本信息', '评价项')
        var field = [
            { _text: '评价项目名称', minWidth: '90%', disabled: true, },
            {
                _buttons: [
                    {
                        _button: '', icon: 'edit', ui: '', docked: 'right',
                        handler: () => Tyan.pubForm.showDialog('评价内容', props => <AddEvaluateItemDiv {...props} id={id} onSave={() => this.handlerInitValue(id)} />),
                    }
                ], width: '40px', margin: 0,
            },
        ]
        list.forEach(o => {
            const list1 = { listName: '评价项', id: o.id }
            const { list: contentList } = getListItems(this, '基本信息', `评价项[${o.id}].内容`)
            field.push(
                {
                    _border: '', name: o.id, list: list1, minWidth: '95%', margin: '15px 0px 0px 0px', items: [
                        { _text: '名称', minWidth: '50%', required: true, disabled: true },
                        {
                            _buttons: [
                                {
                                    _button: '', icon: 'edit', ui: '', margin: '0px 0px 0px 0px', handler:
                                        () => Tyan.pubForm.showDialog('评价标题', props => <EvaluateTitleDiv {...props} evaluateItemID={id} id={o.id}
                                            onSave={() => this.handlerInitValue(id)} />)
                                },
                                {
                                    _button: '', icon: 'trash-o', ui: 'decline', margin: '0px 0px 0px 0px', handler:
                                        () => this.handlerDeleteTitle(o.id)
                                },
                            ], width: 151, margin: 0,
                        },
                        {
                            _grid: '', name: `内容`, rowNumbers: true, maxRows: contentList.length > 3 ? contentList.length : 3, minRows: 1, minWidth: '95%',
                            columns: [
                                { _text: '评价内容', minWidth: 100, flex: 1 },
                                { _int: '分值', minWidth: 80 },
                                {
                                    _text: '考核标准及分值', minWidth: 100, flex: 1,
                                    tools: [
                                        {
                                            _tool: '删除', zone: 'end', handler: (that, data, record) => this.handlerDeleteContent(data.id)
                                        },
                                    ],
                                },
                            ],
                            buttons: [
                                { _button: '添加内容...', ui: '', margin: '0px 15px 0px 0px', handler: () => this.handlerAddEvaluateContent(o.id) },
                            ],
                            onDoubleTap: data => {
                                Tyan.pubForm.showDialog('评价内容', props => <EvaluateContentDiv {...props} id={data.id} onSave={() => this.handlerInitValue(id)} />)
                            },
                        },
                    ]
                }
            )
        })
        return field
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, id, bReadOnly } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="1100"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '新增评价项', icon: 'plus', handler: this.AddEvaluateTitle },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(EvaluateItemDiv)